import { useState } from 'react';

import { useTypedParams } from '@sorare/routing';

import { PrizePoolContenderPage } from '@sorare/gameplay/src/pages/PrizePoolContenderPage';

import { So5LeaderboardContenderDialog } from 'components/lineup/So5LeaderboardContenderDialog';

import { PageParams } from './__generated__/routeParams';

const NBAPrizePoolPage = () => {
  const { leaderboard } = useTypedParams<PageParams>();
  const [selectedContender, setSelectedContender] = useState<string>();

  return (
    <>
      <PrizePoolContenderPage
        leaderboard={leaderboard}
        onClickRanking={setSelectedContender}
      />
      {selectedContender && (
        <So5LeaderboardContenderDialog
          open
          onClose={() => setSelectedContender(undefined)}
          so5LeaderboardContenderSlug={selectedContender}
        />
      )}
    </>
  );
};

export default NBAPrizePoolPage;
